var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemindersLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 17.165H4C4.54494 16.8564 5.00981 16.4242 5.35719 15.9031C5.70457 15.382 5.92474 14.7867 6 14.165V11.165C6.05956 9.89605 6.4633 8.66725 7.16795 7.61028C7.8726 6.5533 8.85159 5.70801 10 5.16498C10 4.63455 10.2107 4.12584 10.5858 3.75076C10.9609 3.37569 11.4696 3.16498 12 3.16498C12.5304 3.16498 13.0391 3.37569 13.4142 3.75076C13.7893 4.12584 14 4.63455 14 5.16498C15.1484 5.70801 16.1274 6.5533 16.8321 7.61028C17.5367 8.66725 17.9404 9.89605 18 11.165M9 17.165V18.165C8.99931 18.8987 9.2675 19.6072 9.75387 20.1565C10.2402 20.7058 10.911 21.0579 11.6394 21.1461C12.3678 21.2343 13.1032 21.0525 13.7067 20.6351C14.3101 20.2177 14.7396 19.5936 14.914 18.881M19 22.165V22.175M19 19.165C19.4483 19.1635 19.8832 19.0118 20.235 18.7339C20.5868 18.4561 20.8352 18.0683 20.9406 17.6325C21.0459 17.1968 21.0019 16.7383 20.8158 16.3304C20.6297 15.9226 20.3122 15.589 19.914 15.383C19.5162 15.1792 19.0611 15.116 18.6228 15.2037C18.1845 15.2914 17.7888 15.5248 17.5 15.866",
    stroke: "#FDFDFD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemindersLink);
export default __webpack_public_path__ + "static/media/reminders-link.6bd873f6e2dd7c33d6fce3968e4b0813.svg";
export { ForwardRef as ReactComponent };